import { AlertCircle, LoaderCircle, RotateCcw } from "lucide-react";
import { presentError } from "../backend/errorPresentation";

export function LoadingState({ label = "Loading" }: { label?: string }) {
  return <div className="state-panel" role="status"><LoaderCircle className="spin" size={22} /><p>{label}</p></div>;
}

export function ErrorState({ error, retry }: { error: unknown; retry: () => void }) {
  const presentation = presentError(error, "load");
  return <div className="state-panel error" role="alert"><AlertCircle size={24} /><h2>{presentation.title}</h2><p>{presentation.message}</p><button className="button" onClick={retry}><RotateCcw size={15} />{presentation.actionLabel}</button></div>;
}
